import { render, staticRenderFns } from "./wtVersionHistoryPanel.vue?vue&type=template&id=6634ad3c&"
import script from "./wtVersionHistoryPanel.vue?vue&type=script&lang=js&"
export * from "./wtVersionHistoryPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports